import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";

export const CreateInvoiceService=async(data)=>{
    try {
        const result = await post(`api/admin/invoice/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateInvoiceService=async(data,id)=>{
    try {
        const result = await put(`api/admin/invoice/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetInvoiceService=async(page,search,from_date,to_date)=>{
    try {
        const result = await get(`api/admin/invoice/get?page=${page}&text=${search}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DownloadInvoiceService=async(page,search,from_date,to_date)=>{
    try {
        const result = await get(`api/admin/invoice/download_excel?page=${page}&text=${search}&from_date=${from_date}&to_date=${to_date}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteInvoiceService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/invoice/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

